import type { ColumnConfig } from '../../../../hooks';

/** Default column configuration for the participants table */
export const DEFAULT_COLUMNS: ColumnConfig[] = [
  { id: 'name', label: 'Participant', visible: true, sortable: true },
  { id: 'email', label: 'Email', visible: false, sortable: true },
  { id: 'role', label: 'Role', visible: true, sortable: true },
  { id: 'business_unit', label: 'Business Unit', visible: true, sortable: true },
  { id: 'location', label: 'Location', visible: false, sortable: true },
  { id: 'personality_type', label: 'I / E', visible: false, sortable: true },
  { id: 'group', label: 'Group', visible: true, sortable: true },
  { id: 'intake_status', label: 'Intake', visible: true, sortable: true },
  { id: 'intake_form_url', label: 'Intake Form URL', visible: false, sortable: false },
  { id: 'midpoint_form_url', label: 'Midpoint Form URL', visible: false, sortable: false },
  { id: 'endpoint_form_url', label: 'Endpoint Form URL', visible: false, sortable: false },
  { id: 'post_session_form_url', label: 'Post Session Form URL', visible: false, sortable: false },
  { id: 'experience', label: 'Experience', visible: false, sortable: false },
  { id: 'primary_goal', label: 'Value', visible: false, sortable: false },
  { id: 'intake_timezone', label: 'Timezone', visible: false, sortable: true },
  { id: 'health', label: 'Health', visible: true, sortable: true },
  // MED-1442: group coaching ("PG" for a peer led cohort, see ParticipantsTableView).
  { id: 'attendance', label: 'GC attendance', visible: true, sortable: true },
  { id: 'sessions', label: 'GC sessions', visible: true, sortable: true },
  // MED-1442: shown only when the cohort has that modality.
  { id: 'attendance_one_on_one', label: '1:1 attendance', visible: true, sortable: false },
  { id: 'attendance_workshop', label: 'W attendance', visible: true, sortable: false },
  { id: 'midpoint_completed', label: 'Midpoint', visible: true, sortable: true },
  { id: 'endpoint_completed', label: 'Endpoint', visible: true, sortable: true },
  { id: 'status', label: 'Status', visible: true, sortable: true },
];

/** Get minimum width for a column based on its type */
export function getColumnMinWidth(columnId: string): number {
  switch (columnId) {
    case 'name': return 280;
    case 'email': return 200;
    case 'role': return 120;
    case 'business_unit': return 140;
    case 'location': return 120;
    case 'personality_type': return 68;
    case 'group': return 120;
    case 'intake_status': return 110;
    case 'intake_form_url': return 120;
    case 'midpoint_form_url': return 140;
    case 'endpoint_form_url': return 140;
    case 'post_session_form_url': return 160;
    case 'experience': return 100;
    case 'primary_goal': return 150;
    case 'intake_timezone': return 100;
    case 'health': return 90;
    case 'attendance': return 140;
    case 'sessions': return 80;
    case 'attendance_one_on_one': return 140;
    case 'attendance_workshop': return 140;
    case 'midpoint_completed': return 100;
    case 'endpoint_completed': return 100;
    case 'status': return 90;
    default: return 120; // Custom fields
  }
}
